let initial = [];

function listHomeBanners(state = initial, action) {
  switch (action.type) {
    case 'UPDATE_HOME_BANNERS_LIST':
      return action.homeBanners;
    default:
      return state;
  }
}

export {listHomeBanners};


// WEBPACK FOOTER //
// ./reducers/home-banners.js